import { Ic } from './kit';

/** The step strip of the import wizards (prototype MODALS.import `.wiz`). */
export function Wiz({ steps, cur }: { steps: string[]; cur: number }) {
  return (
    <ol className="wiz">
      {steps.map((s, i) => <li key={s} className={cur === i + 1 ? 'on' : cur > i + 1 ? 'done' : ''}><span>{cur > i + 1 ? <Ic n="check" /> : i + 1}</span>{s}</li>)}
    </ol>
  );
}
